import { z } from "zod/v4";

export const TextNodeSchema = z.object({
	type: z.literal("text"),
	text: z.string(),
});

const LinkAttributesSchema = z.object({
	to: z.url(),
	external: z.boolean().optional().default(true),
});

export const LinkNodeSchema = z.object({
	type: z.literal("link"),
	attributes: LinkAttributesSchema,
	get children() {
		return z.array(ASTNodeSchema).min(1);
	},
});

export const ParagraphNodeSchema = z.object({
	type: z.literal("paragraph"),
	get children() {
		return z.array(ASTNodeSchema).min(1);
	},
});

export const ASTNodeSchema = z.discriminatedUnion("type", [
	TextNodeSchema,
	LinkNodeSchema,
	ParagraphNodeSchema,
]);

// Root AST schema
export const ASTSchema = z.object({
	get children() {
		return z.array(ASTNodeSchema).min(1);
	},
});
